@import "~/styles/variables";

.ModalToolbar {
  display: flex;
  flex: 0 0 auto;
  padding: $space-xs;

  &:first-child {
    border-bottom: $border-standard;
  }

  &:last-child {
    border-top: $border-standard;
    justify-content: flex-end;
  }
}
